import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { ThemeProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import theme from "@/config/theme";
import App from "./App";
import { ApolloProvider } from "@apollo/client";
import { apolloClient } from "./config/apollo";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { es } from "date-fns/locale/es";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./config/msal";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <ApolloProvider client={apolloClient}>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
            <CssBaseline />
            <App />
          </LocalizationProvider>
        </ThemeProvider>
      </ApolloProvider>
    </MsalProvider>
  </React.StrictMode>
);
